import React from "react";
import styled from "styled-components";
import { Elevation, Spacing, ZIndexes } from "@glossy";
import { onDominant } from "@glossy/theme";
import { Transition } from "@glossy/transitions";

interface IProps {
  children: React.ReactNode;
  className?: string;
}

const Container = styled.div`
  position: relative; /* To initiate stacking context and display shadow! */
  z-index: ${ZIndexes.Menus};
  background-color: ${onDominant};
  box-shadow: ${Elevation.Elevation_4};
  display: flex;
  align-items: center;
  column-gap: ${Spacing.Small};
  height: 60px;
  padding: 0 16px;
  transition: color ${Transition.Color};

  a:hover {
    text-decoration: none;
  }
`;

const KomonNavigationNavbar = ({ children, className }: IProps) => (
  <Container className={className}>{children}</Container>
);

export default KomonNavigationNavbar;
